export default __webpack_public_path__ + "static/media/share.3f476360.png";